import React from 'react'
import RenderHtml from '../../../../../common/AppSpecificConpnents/PartsTable/RenderHtml'
import { formatAsTimezoneLabel } from '../../../../../util/AppUtils'
import { getAuditPreviewReadonlyHaloCheckboxStyle } from '../../../../Documents/components/Nodes/nodeSelectionCheckboxStyles'

const ProcedureStatusInfo = ({
  item_code_type,
  partNumber,
  status,
  revision,
  partDescription,
  showDisabledCheckboxes = false,
  whenSaved,
  partNumberMarginLeft = false,
  /** When true, show explicit "Procedure type:" / "Part number:" lines (audit review / snapshot-backed headers). */
  showLabeledProcedureFields = false,
  /**
   * Single bold title row (item_code_type + part number), sans-serif — matches audit review reference layout.
   * Hides checkbox and label columns; Status / Revision stay in the table row.
   */
  minimalBoldHeader = false,
  checked = false,
  /** When false, no checkbox next to procedure type / part number (e.g. `/audit-trail/preview/`). Tree checkboxes stay controlled elsewhere. */
  showProcedureHeaderCheckbox = true,
}) => {
  const formattedWhenSaved = whenSaved ? formatAsTimezoneLabel(whenSaved) : null
  const applyMargin = showDisabledCheckboxes || partNumberMarginLeft

  const boldTitleText = [item_code_type, partNumber].filter(Boolean).join(" ").trim() || "—"

  const minimalBoldBlock = (
    <div
      style={{
        fontSize: "20px",
        fontWeight: 700,
        fontFamily:
          'system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
        color: "#000",
        lineHeight: 1.3,
      }}
    >
      {boldTitleText}
    </div>
  )

  const labeledProcedureBlock = (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: "6px",
        fontSize: showDisabledCheckboxes ? "18px" : "20px",
      }}
    >
      <div>
        <strong style={{ color: "#6c757d" }}>Procedure type:</strong>{" "}
        <span>{item_code_type ?? "—"}</span>
      </div>
      <div>
        <strong style={{ color: "#6c757d" }}>Part number:</strong>{" "}
        <span>{partNumber ?? "—"}</span>
      </div>
      {formattedWhenSaved && (
        <span
          style={{
            display: "block",
            fontSize: showDisabledCheckboxes ? "10px" : "14px",
            color: "#0D6EFD",
            marginTop: showDisabledCheckboxes ? 0 : "4px",
          }}
        >
          When Saved on {formattedWhenSaved}
        </span>
      )}
    </div>
  )

  const compactHeaderStrong = (
    <strong style={{ fontSize: "20px" }}>
      {item_code_type ? `${item_code_type} ` : ""}
      {partNumber}
      {formattedWhenSaved && (
        <span style={{ display: "block", fontSize: "10px", color: "#0D6EFD" }}>
          When Saved on {formattedWhenSaved}
        </span>
      )}
    </strong>
  )

  const compactProcedureBlock = (
    <>
      {showDisabledCheckboxes && showProcedureHeaderCheckbox && (
        <>
          <label style={{ display: "inline-flex", alignItems: "center", gap: "6px", margin: 0, cursor: "default" }} className="main-checkbox">
            
            <div style={checked?{padding: "2px",paddingBottom:"0px", borderRadius: "6px", backgroundColor: "rgba(13, 110, 253, 0.18)"}:{}}>
              <input type="checkbox"  style={checked?getAuditPreviewReadonlyHaloCheckboxStyle():{}} checked={checked}/></div>
            {compactHeaderStrong}
          </label>
        </>
      )}
      {showDisabledCheckboxes && !showProcedureHeaderCheckbox && compactHeaderStrong}
      {!showDisabledCheckboxes && (
        <strong>
          {item_code_type ? `${item_code_type} ` : ""}
          {partNumber}
          {formattedWhenSaved && (
            <span style={{ display: "block", fontSize: "14px", color: "#0D6EFD", marginTop: "4px" }}>When Saved on {formattedWhenSaved}</span>
          )}
        </strong>
      )}
    </>
  )

  return <>
    {/* Procedure Header Information */}
      <div style={{ marginBottom:"30px" }}>
        <table style={{ width: "100%" }}>
          <tbody>
          <tr>
            <td style={{ width: "70%", fontSize: "20px" }}>
              <div style={{ marginLeft: applyMargin ? "20px" : 0 }}>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", flexWrap: "wrap" }}>
                {minimalBoldHeader ? (
                  minimalBoldBlock
                ) : showLabeledProcedureFields ? (
                  showDisabledCheckboxes && showProcedureHeaderCheckbox ? (
                    <label style={{ display: "inline-flex", alignItems: "flex-start", gap: "8px", margin: 0, cursor: "default" }}>
                      <input type="checkbox" disabled style={{ margin: "4px 0 0 0", cursor: "default", fontSize: "20px" }} />
                      {labeledProcedureBlock}
                    </label>
                  ) : (
                    labeledProcedureBlock
                  )
                ) : (
                  compactProcedureBlock
                )}
              </div>
              </div>

              {/* <div style={{ fontSize: "16px" }}>
                <span style={{ color: "gray" }}>Description:</span> <RenderHtml content={partDescription} />
              </div> */}
            </td>
            <td style={{ width: "15%" }}>
              <strong>Status:</strong>{" "}
              <span style={{ color: "gray" }}>{status ?? "—"}</span>
            </td>
            <td style={{ width: "15%", textAlign: "right" }}>
              <strong>Revision:</strong> {revision ?? "—"}
            </td>
          </tr>
          </tbody>
        </table>
      </div>
  </>
}

export default ProcedureStatusInfo